import { trackEvent } from '../../utils/analytics';

export const sendUserCreatedAnalyticsEvent = async (userId, userParams) => {
  trackEvent('front_create_user', {client_id:userId, label:'front_create_user', ...userParams});
}

export const sendBusinessInfoCompletedAnalyticsEvent = async (clientId, userParams,) => {
  trackEvent('front_user_completed_basic_parameterizations',{client_id:clientId, ...userParams});
}

export const sendPlanSelectedAnalyticsEvent = async ({planType}) => {
  const eventName = planType === 0 ? 'front_selected_free_plan' : 'front_selected_plan_paid';
  trackEvent(eventName,{label:eventName});
}
